const Noodl = require('@noodl/noodl-sdk');
const { CustomTextArea } = require('@prodikt/ui');

module.exports = Noodl.defineReactNode({
	name: 'Prodikt Custom Text Area',
	category: 'Prodikt',
	getReactComponent() {
		return CustomTextArea;
	},
	inputProps: {
		// Basic properties
		label: {
			type: 'string',
			displayName: 'Label',
			group: 'General'
		},
		placeholder: {
			type: 'string',
			displayName: 'Placeholder',
			group: 'General'
		},
		value: {
			type: 'string',
			displayName: 'Value',
			group: 'Data'
		},
		disabled: {
			type: 'boolean',
			displayName: 'Disabled',
			default: false,
			group: 'General'
		},
		required: {
			type: 'boolean',
			displayName: 'Required',
			default: false,
			group: 'General'
		},
		fullWidth: {
			type: 'boolean',
			displayName: 'Full Width',
			default: false,
			group: 'Layout'
		},

		// Size
		rows: {
			type: 'number',
			displayName: 'Rows',
			default: 4,
			group: 'Layout'
		},
		resize: {
			type: {
				name: 'enum',
				enums: [
					{ label: 'None', value: 'none' },
					{ label: 'Vertical', value: 'vertical' },
					{ label: 'Horizontal', value: 'horizontal' },
					{ label: 'Both', value: 'both' }
				]
			},
			displayName: 'Resize',
			default: 'vertical',
			group: 'Layout'
		},

		// Features
		clearable: {
			type: 'boolean',
			displayName: 'Clearable',
			default: false,
			group: 'Features'
		},
		maxLength: {
			type: 'number',
			displayName: 'Max Length',
			group: 'Features'
		},
		showCharCount: {
			type: 'boolean',
			displayName: 'Show Character Count',
			default: false,
			group: 'Features'
		},

		// Messages
		error: {
			type: 'string',
			displayName: 'Error Message',
			group: 'Messages'
		},
		helperText: {
			type: 'string',
			displayName: 'Helper Text',
			group: 'Messages'
		},

		// Styling
		className: {
			type: 'string',
			displayName: 'CSS Class',
			group: 'Style'
		},
		borderColor: {
			type: 'string',
			displayName: 'Border Color',
			group: 'Style'
		}
	},
	outputProps: {
		onChange: {
			type: 'signal',
			displayName: 'Changed'
		},
		onClear: {
			type: 'signal',
			displayName: 'Cleared'
		},
		currentValue: {
			type: 'string',
			displayName: 'Current Value'
		}
	},
	changed: {
		value: function(value) {
			this._outputValue = value || '';
			if (this.outputPropValues) {
				this.outputPropValues.currentValue = value || '';
			}
			this.flagOutputDirty('currentValue');
		}
	},
	update: function() {
		// Sync output if props.value has changed (handles initial connected values)
		const currentValue = this.props.value !== undefined ? this.props.value : '';
		if (this._outputValue !== currentValue) {
			this._outputValue = currentValue;
			if (this.outputPropValues) {
				this.outputPropValues.currentValue = currentValue;
			}
			this.flagOutputDirty('currentValue');
		}
	},
	setup: function(context, graphModel) {
		// Handle style objects
		if (!context.propsInput) context.propsInput = {};
	},
	initialize: function() {
		// Initialize output prop values first
		if (!this.outputPropValues) this.outputPropValues = {};

		// Initialize output value
		const initialValue = this.props.value || '';
		this._outputValue = initialValue;
		this._lastPropsValue = initialValue;
		this.outputPropValues.currentValue = this._outputValue;

		// Flag output as dirty so initial value is sent
		this.flagOutputDirty('currentValue');

		// Poll for value changes from connected inputs
		this._valueCheckInterval = setInterval(() => {
			const currentPropsValue = this.props.value || '';
			if (currentPropsValue !== this._lastPropsValue) {
				this._lastPropsValue = currentPropsValue;
				this._outputValue = currentPropsValue;
				if (this.outputPropValues) {
					this.outputPropValues.currentValue = currentPropsValue;
				}
				this.flagOutputDirty('currentValue');
			}
		}, 50);

		// Set up onChange handler
		this.props.onChange = (value) => {
			this._outputValue = value;
			if (this.outputPropValues) {
				this.outputPropValues.currentValue = value;
			}
			this.setInputValue('value', value);
			this.flagOutputDirty('currentValue');
			this.sendSignalOnOutput('onChange');
		};

		// Set up onClear handler
		this.props.onClear = () => {
			this._outputValue = '';
			if (this.outputPropValues) {
				this.outputPropValues.currentValue = '';
			}
			this.setInputValue('value', '');
			this.flagOutputDirty('currentValue');
			this.sendSignalOnOutput('onClear');
		};
	},
	methods: {
		setValue: function(value) {
			this.setInputValue('value', value);
		},
		getValue: function() {
			return this.props.value || '';
		},
		clearValue: function() {
			this.setInputValue('value', '');
		}
	},
	dispose: function() {
		// Clean up interval when node is disposed
		if (this._valueCheckInterval) {
			clearInterval(this._valueCheckInterval);
		}
	}
});
